import dayjs from "dayjs";

const toNumber = (value) => Number(value) || 0;

/**
 * Indian financial year (April–March) a date falls in, e.g. "2026-27".
 * @param value any date dayjs can parse
 */
export const getFinancialYear = (value) => {
    if (!value) return "—";
    const date = dayjs(value);
    const start = date.month() >= 3 ? date.year() : date.year() - 1;
    return `${start}-${String(start + 1).slice(-2)}`;
};

/**
 * One vendor-payout line of the note, from a debit-note invoice row. GSTIN,
 * invoice date and TDS are read if the payload carries them.
 * @param inv an item of the debit note's invoices endpoint
 */
export const normalizeDebitNoteLine = (inv = {}) => {
    const amount = toNumber(inv.amount);
    const tds = toNumber(inv.tds_amount ?? inv.tds);

    return {
        id           : inv._id || inv.invoice_id,
        vendorName   : inv.holder_name || inv.publisher?.name || "—",
        vendorGstin  : inv.gst_number || inv.gstin || "—",
        invoiceNumber: inv.invoice_number || inv.invoice_ref || "—",
        invoiceUrl   : inv.invoice_url || "",
        invoiceDate  : inv.issue_date || inv.invoice_date || inv.createdAt,
        amount,
        tds,
        net          : inv.net_amount !== undefined && inv.net_amount !== null ? toNumber(inv.net_amount) : amount - tds,
        reference    : inv.payment_reference || inv.utr || "—",
        currency     : inv.currency
    };
};

/**
 * Column totals and the reimbursement claim. With no lines loaded the note's
 * own amount stands in, so the summary is never a row of zeroes.
 * @param lines normalized lines
 * @param note the debit note
 */
export const getDebitNoteTotals = (lines, note) => {
    if (!lines.length) {
        const amount = toNumber(note?.amount);
        return { amount, tds: 0, net: amount };
    }

    return lines.reduce(
        (acc, line) => ({
            amount: acc.amount + line.amount,
            tds   : acc.tds + line.tds,
            net   : acc.net + line.net
        }),
        { amount: 0, tds: 0, net: 0 }
    );
};
